import React from 'react';
import { companyInfo } from '../data/mock';
import { useLanguage } from '../context/LanguageContext';

const HeroSection = () => {
  const { t } = useLanguage();

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-blue-900">
        {/* Animated Grid */}
        <div className="absolute inset-0 opacity-20">
          <div className="absolute inset-0" style={{
            backgroundImage: `linear-gradient(rgba(31, 79, 216, 0.1) 1px, transparent 1px),
                              linear-gradient(90deg, rgba(31, 79, 216, 0.1) 1px, transparent 1px)`,
            backgroundSize: '60px 60px'
          }} />
        </div>
        
        {/* Glowing Orbs */}
        <div className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full blur-3xl animate-pulse" style={{ backgroundColor: 'rgba(31, 79, 216, 0.2)' }} />
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 rounded-full blur-3xl animate-pulse" style={{ backgroundColor: 'rgba(31, 79, 216, 0.2)', animationDelay: '1s' }} />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="max-w-3xl">
          {/* Company Logo */}
          <div className="mb-8">
            <img 
              src="/logo-hero.png" 
              alt="Smart Systems Paraguay" 
              className="h-24 sm:h-32 w-auto rounded-2xl shadow-2xl ring-1 ring-white/10"
              style={{ 
                boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5), 0 0 30px rgba(31, 79, 216, 0.3)'
              }}
              data-testid="hero-logo"
            />
          </div>

          {/* Title */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
            {t.hero.title}
            <span className="block text-transparent bg-clip-text" style={{ backgroundImage: 'linear-gradient(to right, #1F4FD8, #4169E1)' }}>
              {t.hero.subtitle}
            </span>
          </h1>

          {/* Description */}
          <p className="text-xl text-slate-300 leading-relaxed mb-10 max-w-2xl">
            {t.hero.description}
          </p>

          {/* Trust Indicators */}
          <div className="mt-16 pt-8 border-t border-white/10">
            <p className="text-slate-400 text-sm mb-4">{t.hero.trustText}</p>
            <div className="flex items-center gap-8 flex-wrap">
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 rounded-full" style={{ backgroundColor: '#1F4FD8' }} />
                <span className="text-white/80">Auckland, NZ</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 rounded-full" style={{ backgroundColor: '#1F4FD8' }} />
                <span className="text-white/80">Taipei, Taiwan</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 rounded-full" style={{ backgroundColor: '#1F4FD8' }} />
                <span className="text-white/80">Rotterdam, NL</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 rounded-full" style={{ backgroundColor: '#1F4FD8' }} />
                <span className="text-white/80">Munich, DE</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-white/50 rounded-full animate-pulse" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
